import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const userId = process.env.REACT_APP_EMAILJS_USER_ID;
    emailjs.sendForm(serviceId, templateId, e.target, userId)
      .then(() => {
        setStatus('Message sent successfully!');
        setFormData({ name: '', email: '', message: '' });
        e.target.reset();
      }, () => {
        setStatus('Failed to send message. Try again.');
      });
  };

  return (
    <section id="contact" className="relative py-20 bg-gray-900 text-white overflow-hidden">
    <div className="absolute inset-0 pointer-events-none z-0">
      <div className="hidden md:block absolute top-10 left-10 w-80 h-80 bg-pink-500 opacity-10 blur-3xl rounded-full animate-pulse-slow"></div>
      <div className="hidden md:block absolute bottom-10 right-10 w-96 h-96 bg-blue-600 opacity-10 blur-3xl rounded-full animate-pulse-slow"></div>
    </div>

      <div className="container mx-auto text-center px-4 z-10 relative">
        <h2 className="text-3xl md:text-4xl font-extrabold mb-10 drop-shadow-glow">
          Let's Build Something Great Together
        </h2>

        <form
          onSubmit={handleSubmit}
          className="max-w-2xl mx-auto space-y-6 bg-gray-900 bg-opacity-90 p-8 rounded-xl shadow-2xl border border-gray-700"
        >
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Name"
            className="w-full p-4 rounded-md bg-gray-800 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
          />

          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
            className="w-full p-4 rounded-md bg-gray-800 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
          />

          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your Message"
            className="w-full h-40 p-4 rounded-md bg-gray-800 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
            required
          />

          <button
            type="submit"
            className="w-full py-3 px-6 rounded-md text-lg font-semibold text-white bg-gradient-to-r from-cyan-500 via-blue-600 to-indigo-700
            hover:from-indigo-600 hover:to-blue-500 focus:outline-none focus:ring-2 focus:ring-cyan-400 
            shadow-xl transform hover:scale-105 transition-all duration-300 ease-in-out"
          >
            Send Message
          </button>

          {status && <p className="mt-4 text-lg text-green-400">{status}</p>}
        </form>
      </div>
    </section>
  );
};

export default Contact;